import { DashboardPage } from "@/features/dashboard/pages/Dashboard";

const Dashboard = () => {
  return <DashboardPage />;
};

export default Dashboard;
